module.exports = __webpack_public_path__ + "img/register.28c25b4b.svg";